<template>
  <span class="ToomanSvg" dir="ltr">
    <svg class="position-absolute" height="30" width="35">
        <text x="3" y="10" fill="gray">ن</text>
        <text x="6" y="18" fill="gray">توما</text>
    </svg>
  </span>
</template>

<script>
export default {
  name: 'ToomanSvg'
}
</script>

<style scoped>
</style>
